import { X, CaretLeft, CaretRight } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fullscreen image lightbox with prev/next navigation.
 * `images` is the full images array; `index` is the currently displayed image.
 */
export const ImageLightbox = ({ open, images, index, title, onClose, onIndex }) => {
  if (!open || !images?.length) return null;

  const total = images.length;
  const goPrev = (e) => {
    e.stopPropagation();
    onIndex((index - 1 + total) % total);
  };
  const goNext = (e) => {
    e.stopPropagation();
    onIndex((index + 1) % total);
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center"
      data-testid="image-lightbox"
      onClick={onClose}
    >
      <button
        className="absolute top-4 right-4 text-white/70 hover:text-white z-10 p-2"
        onClick={onClose}
        data-testid="lightbox-close"
      >
        <X size={28} />
      </button>
      <button
        className="absolute left-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-3 transition-colors z-10"
        onClick={goPrev}
        data-testid="lightbox-prev"
      >
        <CaretLeft size={24} />
      </button>
      <img
        src={`${API}/files/${images[index]}`}
        alt={`${title} - ${index + 1}`}
        className="max-h-[85vh] max-w-[90vw] object-contain"
        onClick={(e) => e.stopPropagation()}
      />
      <button
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-3 transition-colors z-10"
        onClick={goNext}
        data-testid="lightbox-next"
      >
        <CaretRight size={24} />
      </button>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/60 text-sm">
        {index + 1} / {total}
      </div>
    </div>
  );
};
